(function () {
  'use strict';

  var measurementId = 'G-QPL3NNMC90';
  var tagLoaded = false;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500
  });

  window.__rlAnalyticsAllowed = false;
  window.rlGA = function (name, data) {
    try {
      if (window.__rlAnalyticsAllowed) window.gtag('event', name, data || {});
    } catch (error) {
      // Analytics must never interrupt shopping.
    }
  };

  function loadGoogleTag() {
    if (tagLoaded) return;
    tagLoaded = true;

    window.gtag('js', new Date());
    // Page view is owned by Shopify's Google & YouTube pixel; do not duplicate it.
    window.gtag('config', measurementId, { send_page_view: false });

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
    document.head.appendChild(script);
  }

  function syncConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;

    var analyticsAllowed = privacy.analyticsProcessingAllowed() === true;
    var marketingAllowed = privacy.marketingAllowed() === true;
    window.__rlAnalyticsAllowed = analyticsAllowed;

    window.gtag('consent', 'update', {
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      ad_storage: marketingAllowed ? 'granted' : 'denied',
      ad_user_data: marketingAllowed ? 'granted' : 'denied',
      ad_personalization: marketingAllowed ? 'granted' : 'denied'
    });

    if (analyticsAllowed) loadGoogleTag();
  }

  document.addEventListener('visitorConsentCollected', syncConsent);

  // The API may already be available when this deferred asset executes.
  syncConsent();

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function (error) {
      if (!error) syncConsent();
    });
  }
})();
